import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'

/**
 * @function getStatisticsList
 * @desc 获取统计分析列表
 * @returns {Object}
 */
const getStatisticsList = (st,ed) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/cases_scoring/agg?st=${st}&ed=${ed}`)
    .then(checkResponse)
}

/**
 * @function getRanking
 * @desc 责任主体案件排名
 * @returns {Object}
 */
const getRanking = (st, ed) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/ucases/resorg_order?st=${st}&ed=${ed}`
    )
    .then(checkResponse)
}


/**
 * @function exportStatisticsList
 * @desc 导出统计分析列表
 * @returns {Object}
 */
const exportStatisticsList = (st,ed,type) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/cases_scoring/agg_download?st=${st}&ed=${ed}&type=${type}`)
    .then(checkResponse)
}

/**
 * @function getXZstatistics
 * @desc 新郑市统计分析接口
 * @returns {Object}
 */
const getXZstatistics = (year) => {
  return axios
  .get(`/api/v1/projects/${getProjectId()}/cases_scoring/xzs_statistical?year=${year}`)
  .then(checkResponse)
}

/**
 * @function pcStatistical
 * @desc 新郑市普查统计分析接口
 * @returns {Object}
 */
const pcStatistical = () => {
  return axios
  .get(`/api/v1/projects/${getProjectId()}/cases_scoring/xzs_pc_statistical`)
  .then(checkResponse)
}
const getGZTstatistics = (query) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/ucases/gangzhongtou_group_by?${query}&stage=closed`
    )
    .then(checkResponse)
}
/**
 * @function getDlstatistics
 * @desc 大连垃圾分类考核得分统计
 * @returns {Object}
 */
const getDlstatistics = (query) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/ucases/dlljfl_group_by_area?${query}`
    )
    .then(checkResponse)
}

export{
  getStatisticsList,
  getRanking,
  exportStatisticsList,
  getXZstatistics,
  pcStatistical,
  getGZTstatistics,
  getDlstatistics
}
